import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'aws-amplify/auth/enable-oauth-listener';
import { configureAuth } from './lib/auth';
import { SessionProvider } from './lib/session';
import { App } from './App';
import { RouteTitle } from './lib/title';
import './styles/global.css';

configureAuth();

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SessionProvider>
          <RouteTitle />
          <a className="skip-link" href="#main">
            Skip to content
          </a>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
